import { CleanDeliveryOrder } from '../../../export-types/cleaned-types';
import { useIntl } from 'react-intl';
import { InputWrapper } from '../../common/input-wrapper';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { getPrefixByType } from '../../common/cards/id-cell-card.component';
import useSWR from 'swr';
import { fetcher } from '../../../services/api';

export function DeliveryOrderRelatedParcels(props: {
  deliveryOrder: CleanDeliveryOrder;
}) {
  const intl = useIntl();

  const { data } = useSWR<{
    relatedPurchaseOrders?: Array<{
      type: 'parcel' | 'purchase';
      internalId: number;
      uuid: string;
    }>;
    relatedDeliveryOrders?: Array<{
      internalId: number;
      uuid: string;
    }>;
  }>(`/delivery-order/${props.deliveryOrder.id}/relations`, fetcher);

  return (
    <>
      {
        <InputWrapper
          theme="light"
          className="mt-3"
          title={intl.formatMessage({
            defaultMessage: 'Связанные посылки',
            id: 'purchaseOrderRelatedParcels.label-input.relatedParcel',
            description: 'Информация о связанных посылках',
          })}
        >
          {data?.relatedPurchaseOrders?.map((purchaseOrder, index) => {
            return (
              <NavLink
                to={`/${purchaseOrder.type === 'parcel' ? 'parcels' : 'purchases'}/${purchaseOrder.uuid}`}
              >
                {getPrefixByType(purchaseOrder.type)}
                {purchaseOrder.internalId}
                {index !== (data?.relatedPurchaseOrders?.length || 0) - 1
                  ? '; '
                  : ''}
              </NavLink>
            );
          })}
        </InputWrapper>
      }
      {
        <InputWrapper
          theme="light"
          className="mt-3"
          title={intl.formatMessage({
            defaultMessage: 'Связанные доставки',
            id: 'purchaseOrderRelatedParcels.label-input.relatedDeliveryOrders',
            description: 'Информация о связанных посылках',
          })}
        >
          {data?.relatedDeliveryOrders?.map((order, index) => {
            return (
              <NavLink to={`/deliveries/delivery-order/${order.uuid}`}>
                {getPrefixByType('delivery')}
                {order.internalId}
                {index !== (data?.relatedDeliveryOrders?.length || 0) - 1
                  ? '; '
                  : ''}
              </NavLink>
            );
          })}
        </InputWrapper>
      }
    </>
  );
}
